// extracted by mini-css-extract-plugin
export default {"services":"styles_services__EhWrQ"};